import React, { useContext } from "react";
import './posture.css';
import MetricsContainer from "./Metrics/Metrics-container";
import { RootContext } from "../../../contexts/root-context";
import JsonData from './posture.json'
import perdueDigram from "./perdueDiagram.png"
import SBOMUploader from "./SBOMUploader"
import { Button } from "@abb/abb-common-ux-react";
import PropTypes from 'prop-types';
const Indicator = ({ color, x, y }) => (
    <div
        className="indicator"
        style={{
            backgroundColor: color,
            left: x,
            top: y,

        }}
    />
);
Indicator.propTypes = {
    color: PropTypes.string.isRequired,
    x: PropTypes.string.isRequired,
    y: PropTypes.string.isRequired,
};
function Posture() {

    const { showConfigureSBOMPage, setShowConfigureSBOMPage } = useContext(RootContext);


    const handleConfigureClick = () => {
        setShowConfigureSBOMPage(true);
    };

    const { deviceData } = useContext(RootContext);

    console.log("dat", deviceData)

    const targetDevices = [
        "Zenon_Main_Server",
        "EL_Gateway",
        "Open_PLC",
        "REX615_1",
        "REX615_2"
    ];

    const devicesArray = deviceData?.data || [];
    //   const devicesArray = deviceData.data || [];

    const filteredDevices = devicesArray.filter(device =>
        targetDevices.includes(device.DeviceName)
    );

    console.log("Filtered Devices:", filteredDevices);


    const deviceIndicatorPositions = {
        "Zenon_Main_Server": { x: "17.11%", y: "51%" },
        "EL_Gateway": { x: "31%", y: "51%" },
        "Open_PLC": { x: "14%", y: "69%" },
        "REX615_1": { x: "30%", y: "69%" },
        "REX615_2": { x: "38%", y: "69%" }
    };


    const indicatorsData = filteredDevices.map(device => {
        const position = deviceIndicatorPositions[device.DeviceName] || { x: "0px", y: "0px" };
        return {
            color: device.Status === "Connected" ? "green" : "red",
            x: position.x,
            y: position.y,
            name: device.DeviceName
        };
    });

    console.log("All Indicators:", indicatorsData);



    if (showConfigureSBOMPage) {
        return <SBOMUploader />;
    }


    return (
        <>
            {/* <SBOMUploader /> */}
            <div className="configure-sbom">
                {JsonData?.configureSBOMButton?.enable && (
                    <Button
                        style={{ margin: "10px", width: "160px" }}
                        {...JsonData.configureSBOMButton.properties}
                        onClick={handleConfigureClick}
                    />
                )}
            </div>

            <h1 className="posture-heading">{JsonData.PostureHeading.label}</h1>
            <MetricsContainer />
            <div className="digram">


                <img src={perdueDigram} alt="Perdue Diagram" />
                {indicatorsData.map((indicator, index) => (
                    <Indicator
                        key={indicator.name}
                        color={indicator.color}
                        x={indicator.x}
                        y={indicator.y}
                    />
                ))}
            </div>
        </>
    );
}

export default Posture;


